"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1633],{

/***/ 59084:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ CardTenantMyClass; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36734);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70257);
/* harmony import */ var components_Icon_IconStar__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28939);
/* harmony import */ var lib_helper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99601);
/* harmony import */ var components_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61097);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86880);
/* harmony import */ var modules_Auth_authStore__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(40474);
/* harmony import */ var lib_device__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(59799);
/* harmony import */ var components_Icon_IconChevronRight__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(42343);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(51776);
/* harmony import */ var components_Icon_IconPlayCircle__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(14016);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(67832);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var components_PageHeader_systemStore__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(96937);
/* harmony import */ var components_Icon_IconClose__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(84132);














const CardTenantMyClass = (props)=>{
    const [theme] = (0,components_PageHeader_systemStore__WEBPACK_IMPORTED_MODULE_12__/* .useSystemStore */ .m)((state)=>[
            state.theme
        ]);
    const { height =120 , isHomePage =false , onHide  } = props;
    const hasUserPaid = props.is_paid;
    const hasCertificate = props.has_certificate;
    const hasPaywall = props.is_paywall_enabled === undefined ? true : props.is_paywall_enabled;
    const isCourseFree = props.original_price === 0 || props.discounted_price === 0;
    const hasFinished = props.enrollment_progress?.finished;
    const isNumber = typeof props.enrollment_progress?.finished === "number";
    const totalLesson = props.enrollment_progress?.total || 0;
    const institutionName = //@ts-ignore
    props.institution?.name || props.institution?.split("||")[0] || "";
    const isCourseFinished = isNumber ? hasFinished === props.enrollment_progress?.total : 0;
    const { t  } = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("course");
    const isDesktop = (0,lib_device__WEBPACK_IMPORTED_MODULE_7__/* .useIsDesktop */ .Ce)();
    const currentUser = (0,modules_Auth_authStore__WEBPACK_IMPORTED_MODULE_6__/* .useAuthStore */ .t)((state)=>state.currentUser);
    const isEnterprisePlus = currentUser?.tenant !== undefined && [
        "Enterprise Plus",
        "Pro Plus",
        `Pro Custom (${currentUser?.referral})`
    ].includes(currentUser?.tenant?.plan?.name);
    // const cardHeight = isDesktop ? height : 116;
    const [cardHeight, setCardHeight] = (0,react__WEBPACK_IMPORTED_MODULE_9__.useState)(height);
    (0,react__WEBPACK_IMPORTED_MODULE_9__.useEffect)(()=>{
        const widthWindow =  true && window.innerWidth;
        const window20 = 0.2 * widthWindow;
        if (window20 < cardHeight) {
            setCardHeight(window20);
        }
    }, [
        window
    ]);
    const [showTooltip, setShowTooltip] = (0,react__WEBPACK_IMPORTED_MODULE_9__.useState)(false);
    const [tooltipPosition, setTooltipPosition] = (0,react__WEBPACK_IMPORTED_MODULE_9__.useState)({
        top: 0,
        left: 0
    });
    const handleMouseEnter = (e)=>{
        const rect = e.currentTarget.getBoundingClientRect();
        setTooltipPosition({
            top: rect.top - 32,
            left: rect.left - 14
        });
        setShowTooltip(true);
    };
    const handleMouseLeave = ()=>setShowTooltip(false);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: `rounded-8 overflow-hidden min-w-[270px] w-[31vw] flex h-[132px] cursor-pointer border border-neutral20_to_black`,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: `w-[132px] max-w-[305px] relative overflow-hidden flex-shrink-0 bg-white`,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_11___default()), {
                        alt: props.name,
                        src: props.image_cover_url,
                        height: 132,
                        width: 132,
                        className: `h-full w-full object-cover aspect-[1/1]`
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "absolute top-0 grid-cols-1 w-full h-full",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "h-[100%] flex justify-center items-center",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Icon_IconPlayCircle__WEBPACK_IMPORTED_MODULE_10__/* .IconPlayCircle */ .U, {
                                size: 45,
                                classes: "m-auto",
                                isBgCustomized: true
                            })
                        })
                    }),
                    isCourseFinished ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "absolute bottom-8 right-8",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "rounded-16 bg-green-10 text-green-90 px-8 py-4 text-c1 font-medium flex justify-center items-center",
                            children: "Completed"
                        })
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "relative bg-white_to_dark10 w-full text-neutral-80 flex flex-col justify-between px-10 py-10",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-b2 font-light text-neutral80_to_dark10 md-max:hidden",
                                children: institutionName
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                className: "text-b1 font-medium max-w-full line-clamp-1 text-neutral80_to_dark10",
                                children: props.name
                            })
                        ]
                    }),
                    hasPaywall && !hasUserPaid && isCourseFinished && // (isEnterprisePlus || hasCertificate) ? (
                    // remove validate OR
                    isEnterprisePlus && hasCertificate ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        variant: "secondary_white",
                        size: "medium",
                        isFull: true,
                        className: "px-0",
                        children: t("downloadCertif")
                    }) : isNumber ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex items-center mb-4",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: `flex-1 h-6 bg-light_neutral10_to_dark_neutral50 relative overflow-hidden rounded-full`,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "h-full absolute left-0 top-0 rounded-full bg-violet_main_to_dark_purple_surface",
                                    style: {
                                        width: hasFinished / totalLesson * 100 + "%",
                                        transition: "width 0.5s ease-in-out"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: `text-b2 font-light ${isCourseFinished ? "text-green50_to_white" : "text-violet_main_to_dark_purple_surface"}`,
                                children: isCourseFinished ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: "Selesai"
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "ml-8 md-max:hidden",
                                            children: (hasFinished / props.enrollment_progress?.total * 100).toString().slice(0, 4) + "%"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                            className: "ml-8 md-max:block hidden",
                                            children: [
                                                hasFinished,
                                                " dari ",
                                                props.enrollment_progress?.total
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex gap-x-8 justify-start items-center text-c1 font-light",
                        children: [
                            typeof props?.review_summary?.star_avg === "number" && //@ts-ignore
                            props?.review_summary?.star_avg !== 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex items-center justify-center",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Icon_IconStar__WEBPACK_IMPORTED_MODULE_2__/* .IconStar */ .G, {
                                                size: 14,
                                                fill: true,
                                                color: "#EFB443"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "ml-2 text-c1",
                                                children: (0,lib_helper__WEBPACK_IMPORTED_MODULE_3__/* .formatRating */ .A6)(props?.review_summary?.star_avg.toFixed(1))
                                            })
                                        ]
                                    }),
                                    "|"
                                ]
                            }) : null,
                            props.total_learners !== 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                children: `${(0,lib_helper__WEBPACK_IMPORTED_MODULE_3__/* .numberWithCommas */ .x6)(props.total_learners)} pelajar`
                            })
                        ]
                    }),
                    isHomePage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: " md-max:hidden bg-white_to_dark_neutral70 max-h-44 md:max-h-50 border border-neutral-10 p-8 flex-1 flex justify-between items-center rounded-8",
                        style: {
                            boxShadow: "1px 1px 6px 0px rgba(0, 0, 0, 0.1)"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                        className: "text-c1 mb-4 font-medium text-purple70_to_dark10 line-clamp-1",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "text-orange-50",
                                                children: `${props?.is_remaining_duration}m`
                                            }),
                                            " ",
                                            t("toCompleteChapter"),
                                            ":"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "text-purple70_to_dark10 text-b2 font-medium line-clamp-1",
                                        children: props.is_chapter_name
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Icon_IconChevronRight__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                    color: "#2A1060",
                                    size: 16
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        onClick: (e)=>{
                            e.preventDefault();
                            e.stopPropagation();
                            onHide(props.slug);
                        },
                        onMouseEnter: handleMouseEnter,
                        onMouseLeave: handleMouseLeave,
                        className: "absolute top-8 right-8 z-20",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Icon_IconClose__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                            size: 16,
                            color: theme === "dark" ? "#FFFFFF" : "#3E3851"
                        })
                    }),
                    showTooltip && /*#__PURE__*/ react_dom__WEBPACK_IMPORTED_MODULE_1__.createPortal(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        style: {
                            position: "absolute",
                            top: tooltipPosition.top,
                            left: tooltipPosition.left,
                            zIndex: 9999
                        },
                        className: "w-[42px] h-[24px] text-c1 text-white py-[4px] px-[8px] bg-[#464647] rounded-[6px] pointer-events-none whitespace-nowrap text-center",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "font-[12px] font-[274]",
                                children: "Hide"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "absolute -bottom-[5px] right-12 rotate-180 border-l-[8px] border-l-transparent border-r-[8px] border-r-transparent",
                                style: {
                                    borderBottom: "5px solid #464647"
                                }
                            })
                        ]
                    }), document.body)
                ]
            })
        ]
    });
};


/***/ }),

/***/ 42343:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36734);
/* harmony import */ var components_PageHeader_systemStore__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96937);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51776);



const IconChevronRight = ({ size =24 , color ="#3E3851"  })=>{
    const theme = (0,components_PageHeader_systemStore__WEBPACK_IMPORTED_MODULE_1__/* .useSystemStore */ .m)((state)=>state.theme);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M15.5388 11.29L9.87876 5.64001C9.7858 5.54628 9.6752 5.47188 9.55334 5.42111C9.43148 5.37035 9.30077 5.34421 9.16876 5.34421C9.03675 5.34421 8.90604 5.37035 8.78418 5.42111C8.66233 5.47188 8.55172 5.54628 8.45876 5.64001C8.27251 5.82737 8.16797 6.08082 8.16797 6.34501C8.16797 6.60919 8.27251 6.86264 8.45876 7.05001L13.4088 12.05L8.45876 17C8.27251 17.1874 8.16797 17.4408 8.16797 17.705C8.16797 17.9692 8.27251 18.2226 8.45876 18.41C8.55138 18.5045 8.66182 18.5797 8.7837 18.6312C8.90557 18.6827 9.03645 18.7095 9.16876 18.71C9.30107 18.7095 9.43195 18.6827 9.55383 18.6312C9.6757 18.5797 9.78615 18.5045 9.87876 18.41L15.5388 12.76C15.6403 12.6664 15.7213 12.5527 15.7767 12.4262C15.8321 12.2997 15.8607 12.1631 15.8607 12.025C15.8607 11.8869 15.8321 11.7503 15.7767 11.6238C15.7213 11.4973 15.6403 11.3836 15.5388 11.29Z",
            fill: theme == "dark" ? "#FFF" : color
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (IconChevronRight);


/***/ }),

/***/ 37424:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H7": function() { return /* binding */ getCourseFromIndexedDB; },
/* harmony export */   "KG": function() { return /* binding */ deleteVideoFromIndexedDB; },
/* harmony export */   "NG": function() { return /* binding */ saveCourseToIndexedDB; },
/* harmony export */   "R0": function() { return /* binding */ getVideoFromIndexedDB; },
/* harmony export */   "hN": function() { return /* binding */ getAllCoursesFromIndexedDB; },
/* harmony export */   "sM": function() { return /* binding */ saveVideoToIndexedDB; },
/* harmony export */   "sb": function() { return /* binding */ deleteCourseFromIndexedDB; }
/* harmony export */ });
/* unused harmony exports openDatabase, openVideoDatabase */
const openDatabase = ()=>{
    return new Promise((resolve, reject)=>{
        const request = indexedDB.open("courseDB", 1);
        request.onupgradeneeded = function(event) {
            const db = event.target.result;
            if (!db.objectStoreNames.contains("courses")) {
                const objectStore = db.createObjectStore("courses", {
                    keyPath: "slug"
                });
                objectStore.createIndex("slug", "slug", {
                    unique: true
                });
            }
        };
        request.onsuccess = function(event) {
            resolve(event.target.result);
        };
        request.onerror = function(event) {
            reject(event.target.error);
        };
    });
};
const openVideoDatabase = ()=>{
    return new Promise((resolve, reject)=>{
        const request = indexedDB.open("videoDB", 1);
        request.onupgradeneeded = function(event) {
            const db = event.target.result;
            if (!db.objectStoreNames.contains("videos")) {
                db.createObjectStore("videos", {
                    keyPath: "slug"
                });
            }
        };
        request.onsuccess = function(event) {
            resolve(event.target.result);
        };
        request.onerror = function(event) {
            reject(event.target.error);
        };
    });
};
const saveCourseToIndexedDB = async (courseSlug, currentUser, courseData)=>{
    try {
        const db = await openDatabase();
        const transaction = db.transaction("courses", "readwrite");
        const store = transaction.objectStore("courses");
        const request = store.put({
            slug: courseSlug,
            user: currentUser,
            data: courseData
        });
        request.onsuccess = function() {
            ;
        };
        request.onerror = function(event) {
            ;
        };
    } catch (error) {
        ;
    }
};
const saveVideoToIndexedDB = async (lessonSlug, videoUrl)=>{
    try {
        const db = await openVideoDatabase();
        const response = await fetch(videoUrl);
        const blob = await response.blob();
        const videoBlob = new Blob([
            blob
        ], {
            type: "video/mp4"
        });
        const transaction = db.transaction("videos", "readwrite");
        const store = transaction.objectStore("videos");
        const request = store.put({
            slug: lessonSlug,
            video: videoBlob
        });
        request.onsuccess = function() {
            ;
        };
        request.onerror = function(event) {
            ;
        };
        await new Promise((resolve, reject)=>{
            transaction.oncomplete = ()=>resolve();
            transaction.onerror = (event)=>reject(event);
        });
    } catch (error) {
        ;
    }
};
const getCourseFromIndexedDB = async (courseSlug)=>{
    try {
        const db = await openDatabase();
        const transaction = db.transaction("courses", "readonly");
        const store = transaction.objectStore("courses");
        const request = store.get(courseSlug);
        return new Promise((resolve, reject)=>{
            request.onsuccess = function(event) {
                if (request.result) {
                    resolve(request.result.data);
                } else {
                    reject(`No data found for slug ${courseSlug}`);
                }
            };
            request.onerror = function() {
                reject("Failed to retrieve data from IndexedDB");
            };
        });
    } catch (error) {
        ;
    }
};
const getVideoFromIndexedDB = async (lessonSlug)=>{
    try {
        const db = await openVideoDatabase();
        const transaction = db.transaction("videos", "readonly");
        const store = transaction.objectStore("videos");
        const request = store.get(lessonSlug);
        return new Promise(async (resolve, reject)=>{
            request.onsuccess = function(event) {
                const request = event.target.result;
                if (request) {
                    const videoUrl = URL.createObjectURL(request.video);
                    resolve(videoUrl);
                } else {
                    reject(`No video found for slug ${lessonSlug}`);
                }
            };
            request.onerror = function() {
                reject("Failed to retrieve video from IndexedDB");
            };
            await new Promise((resolve, reject)=>{
                transaction.oncomplete = ()=>resolve();
                transaction.onerror = (event)=>reject(event);
            });
        });
    } catch (error) {
        ;
    }
};
const getAllCoursesFromIndexedDB = async ()=>{
    try {
        const db = await openDatabase();
        const transaction = db.transaction("courses", "readonly");
        const store = transaction.objectStore("courses");
        const request = store.getAll();
        return new Promise((resolve, reject)=>{
            request.onsuccess = function(event) {
                resolve(event.target.result);
            };
            request.onerror = function() {
                reject("Failed to retrieve data from IndexedDB");
            };
        });
    } catch (error) {
        ;
    }
};
const deleteCourseFromIndexedDB = async (slug)=>{
    try {
        const db = await openDatabase();
        const transaction = db.transaction("courses", "readwrite");
        const store = transaction.objectStore("courses");
        const request = store.delete(slug);
        return new Promise((resolve, reject)=>{
            request.onsuccess = function(event) {
                resolve("Course deleted successfully");
            };
            request.onerror = function() {
                reject("Failed to delete course from IndexedDB");
            };
        });
    } catch (error) {
        ;
    }
};
const deleteVideoFromIndexedDB = async (slug)=>{
    try {
        const db = await openVideoDatabase();
        const transaction = db.transaction("videos", "readwrite");
        const store = transaction.objectStore("videos");
        const request = store.delete(slug);
        return new Promise((resolve, reject)=>{
            request.onsuccess = function(event) {
                resolve("Video deleted successfully");
            };
            request.onerror = function() {
                reject("Failed to delete video from IndexedDB");
            };
        });
    } catch (error) {
        ;
    }
};


/***/ }),

/***/ 16120:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36734);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51776);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86880);
/* harmony import */ var components_Modal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59177);
/* harmony import */ var components_Skeleton_Skeleton__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9978);
/* harmony import */ var _modalSectionStore__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(820);
/* harmony import */ var components_Card_CardCourseWithLesson__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(97216);
/* harmony import */ var react_spinners__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(13173);
/* harmony import */ var lib_device__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(59799);
/* harmony import */ var components_Card_CardCourseBundle__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(87948);










const ModalSectionsDetail = ({ isBundle =false , mainContentHeight  })=>{
    const { t  } = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("common");
    const isDesktop = (0,lib_device__WEBPACK_IMPORTED_MODULE_7__/* .useIsDesktop */ .Ce)();
    const [title, isShow, isShowBundle, setIsShow, setIsShowBundle, data, isLoading] = (0,_modalSectionStore__WEBPACK_IMPORTED_MODULE_5__/* .useModalSectionStore */ .y)((state)=>[
            state.title,
            state.isShow,
            state.isShowBundle,
            state.setIsShow,
            state.setIsShowBundle,
            state.data,
            state.isLoading
        ]);
    // Load More
    const [visibleData, setVisibleData] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(data?.slice(0, 9) || []);
    const [hasMoreData, setHasMoreData] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true);
    const observerRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const loadMoreData = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(()=>{
        if (data) {
            const nextData = data.slice(visibleData.length, visibleData.length + 9);
            setVisibleData((prev)=>{
                const updatedData = [
                    ...prev,
                    ...nextData
                ];
                return Array.from(new Set(updatedData));
            });
            if (visibleData.length + nextData.length >= data.length) {
                setHasMoreData(false);
            }
        }
    }, [
        data,
        visibleData.length
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (data) {
            setVisibleData(data.slice(0, 9));
            setHasMoreData(true);
        }
    }, [
        data
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const observer = new IntersectionObserver((entries)=>{
            if (entries[0].isIntersecting && hasMoreData) {
                loadMoreData();
            }
        }, {
            threshold: 0.5
        });
        if (observerRef.current) {
            observer.observe(observerRef.current);
        }
        return ()=>{
            if (observerRef.current) {
                observer.unobserve(observerRef.current);
            }
        };
    }, [
        hasMoreData,
        loadMoreData
    ]);
    // End Load More
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (visibleData) {
            setShuffledData(visibleData);
        }
    }, [
        visibleData
    ]);
    const [shuffledData, setShuffledData] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(visibleData || []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if ((title !== t("sectionNew") || title !== "Kursus Paling Banyak Dicari" || // @ts-ignore
        title !== "Kursus Terdownload") && !isBundle) {
            const shuffled = [
                ...data
            ].sort(()=>Math.random() - 0.5);
            setShuffledData(shuffled);
        }
    }, [
        data.length,
        isBundle
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Modal__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        title: title,
        isShow: isShow || isShowBundle,
        contentClassName: "min-w-[90vw]",
        onClose: ()=>isShowBundle ? setIsShowBundle(false) : setIsShow(false),
        isFullScreen: true,
        isBundles: isBundle,
        mainContentHeight: mainContentHeight,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: `${!isBundle ? "grid grid-cols-3 gap-20 px-16 pt-20 pb-40" : "flex flex-col"} max-h-[75vh] overflow-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]`,
            children: isLoading ? Array.from({
                length: 9
            }).map((a, __)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_Skeleton_Skeleton__WEBPACK_IMPORTED_MODULE_4__/* .SkeletonWrapper */ .nR, {
                    className: "grid gap-8",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Skeleton_Skeleton__WEBPACK_IMPORTED_MODULE_4__/* .SkeletonRect */ .a8, {
                            className: "rounded-4 h-[223px]"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Skeleton_Skeleton__WEBPACK_IMPORTED_MODULE_4__/* .SkeletonRect */ .a8, {
                            className: "rounded-4 h-[76px]"
                        })
                    ]
                })) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    title === t("sectionNew") || title === "Kursus Paling Banyak Dicari" || title === "Kursus Terdownload" ? visibleData.map((elm, index)=>{
                        const previousCourse = visibleData[index - 1];
                        return isBundle || isShowBundle ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Card_CardCourseBundle__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            ...elm,
                            isRow: isBundle,
                            previousCourse: previousCourse,
                            courseIndex: index,
                            isBundles: isShowBundle,
                            tracker: {
                                event: "b2b_homepage_course_a",
                                property: {
                                    course_name: elm?.name,
                                    course_slug: elm?.slug,
                                    institution_name: elm?.institution?.name,
                                    category_name: title,
                                    section: title,
                                    index,
                                    is_mandatory_course: false
                                }
                            },
                            isModal: true
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Card_CardCourseWithLesson__WEBPACK_IMPORTED_MODULE_6__["default"], {
                            ...elm,
                            isRow: isBundle,
                            tracker: {
                                event: "b2b_homepage_course_a",
                                property: {
                                    course_name: elm?.name,
                                    course_slug: elm?.slug,
                                    institution_name: elm?.institution?.name,
                                    category_name: title,
                                    section: title,
                                    index,
                                    is_mandatory_course: false
                                }
                            },
                            isModal: true
                        });
                    }) : shuffledData.map((elm, index)=>{
                        const previousCourse = shuffledData[index - 1];
                        return isBundle || isShowBundle ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Card_CardCourseBundle__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            ...elm,
                            isRow: isBundle,
                            previousCourse: previousCourse,
                            courseIndex: index,
                            isBundles: isShowBundle,
                            tracker: {
                                event: "b2b_homepage_course_a",
                                property: {
                                    course_name: elm?.name,
                                    course_slug: elm?.slug,
                                    institution_name: elm?.institution?.name,
                                    category_name: title,
                                    section: title,
                                    index,
                                    is_mandatory_course: false
                                }
                            },
                            isModal: true
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Card_CardCourseWithLesson__WEBPACK_IMPORTED_MODULE_6__["default"], {
                            ...elm,
                            isRow: isBundle,
                            tracker: {
                                event: "b2b_homepage_course_a",
                                property: {
                                    course_name: elm?.name,
                                    course_slug: elm?.slug,
                                    institution_name: elm?.institution?.name,
                                    category_name: title,
                                    section: title,
                                    index,
                                    is_mandatory_course: false
                                }
                            },
                            isModal: true
                        });
                    }),
                    hasMoreData && data.length > visibleData.length && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        ref: observerRef,
                        className: "mt-10 flex justify-center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_spinners__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                            size: isDesktop ? 45 : 20
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ModalSectionsDetail);


/***/ })

}]);